export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/ios_android_dual.40204c4.svg";